<template>
    <div>
        <van-form @submit="onSubmit" :rules="formRules">
            <van-field v-model="attendanceDetail.classDate" label="上课日期" readonly />
            <van-field v-model="attendanceDetail.startTime" label="上课开始时间" readonly />
            <van-field v-model="attendanceDetail.endTime" label="上课开始时间" readonly />
            <van-field v-model="attendanceDetail.teacherName" label="上课教师" readonly/>
            <van-field v-model="attendanceDetail.courseName" label="课程" readonly/>

            <van-field label="是否跨校区">
                <template #input>
                    <van-switch v-model="attendanceDetail.isTransCampus" />
                </template>
            </van-field>

            <van-field v-model="attendanceDetail.overClassHour" label="加班课时" placeholder="请输入加班课时数" type="number" />

            <div style="margin: 16px;">
                <van-button round block type="primary" native-type="submit">
                    保存
                </van-button>
            </div>

            <!-- 加载遮罩 -->
            <van-overlay :show="loading">
                <div class="loading-wrapper">
                    <van-loading size="24px">提交中...</van-loading>
                </div>
            </van-overlay>
        </van-form>
    </div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import { getAttendanceDetailByPlanIdForH5, updateAttendanceSchedulePlan } from '@/api/schedule';

const route = useRoute();
const loading = ref(false);
const schedulePlanId = ref(null);
const courseId = ref(null);

const attendanceDetail = reactive({
    startTime: '',
    endTime: '',
    isTransCampus: false,
    overClassHour: 0,
    classDate: '',
    teacherName: '',
    courseName: ''
});

const formRules = [
    {
        validator: (val) => val >= 0,
        message: '加班课时不能为负数',
        trigger: 'blur',
        field: 'overClassHour'
    }
];

onMounted(() => {
    schedulePlanId.value = route.query.schedulePlanId;
    courseId.value = route.query.courseId;
    getSchedulePlan();
});

function getSchedulePlan() {
    getAttendanceDetailByPlanIdForH5(schedulePlanId.value).then(response => {
        Object.assign(attendanceDetail, response);
        attendanceDetail.classDate = attendanceDetail.startDateTime?.split(" ")[0] || '';
        
        // 设置开始时间
        if (response.startDateTime) {
            const startTime = response.startDateTime.split(" ")[1].slice(0, -3);
            attendanceDetail.startTime = startTime;
        }
        // 设置结束时间
        if (response.endDateTime) {
            const endTime = response.endDateTime.split(" ")[1].slice(0, -3);
            attendanceDetail.endTime = endTime;
        }
        // 确保isTransCampus是布尔值
        attendanceDetail.isTransCampus = Boolean(response.isTransCampus || false);
        attendanceDetail.overClassHour = Number(response.overClassHour || 0);
    });
}

function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

function onSubmit() {
    loading.value = true;
    const param = {
        schedulePlanId: schedulePlanId.value,
        isTransCampus: attendanceDetail.isTransCampus ? 1 : 0,
        overClassHour: attendanceDetail.overClassHour,
    };
    
    updateAttendanceSchedulePlan(param).then(() => {
        import('vant').then(vant => {
            vant.showSuccessToast('修改成功');
        });
    }).catch(() => {
        // 错误处理
    }).finally(() => {
        loading.value = false;
    });
}
</script>

<style scoped>
/* 弹窗内容区域 */
.van-popup--bottom {
    background-color: #fff;
}

/* 搜索框样式 */
.van-search {
    padding: 10px 16px;
}

/* 列表项样式 */
.van-cell {
    border-bottom: 1px solid #ebedf0;
}

.loading-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
</style>
